<nibtravel-base-layout
  [theme]="themeConfig"
  loader="preloader"
  #themeLoader="theme"
  [logoConfig]="(themeLoader.logoChanged$ | async)?.logo"
  [footerConfig]="footerConfig$ | async"
>
  <ng-container content>
    <router-outlet></router-outlet>
  </ng-container>
</nibtravel-base-layout>
